import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ListMembersResponseElement } from '../types/apiGeneratedTypes';

export interface MembersPageState {
  searchValue: string;
  appliedFilters: string[];
  isAddMemberModalOpened: boolean;
  memberDataToEdit: ListMembersResponseElement | null;
  membersList: ListMembersResponseElement[] | null;
  limit: number;
  memberIdToEdit: string | null;
  memberIdToToggle: string | null;
  sortKey: string | null;
  sortOrder: 'asc' | 'desc';
}

export const initialState: MembersPageState = {
  searchValue: '',
  appliedFilters: [],
  isAddMemberModalOpened: false,
  memberDataToEdit: null,
  membersList: null,
  limit: 10,
  memberIdToEdit: null,
  memberIdToToggle: null,
  sortKey: null,
  sortOrder: 'asc',
};

const membersPageSlice = createSlice({
  name: 'members',
  initialState,
  reducers: {
    setMembersPageSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    clearMembersPageSearchValue(state) {
      state.searchValue = '';
    },
    addFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = [...state.appliedFilters, action.payload];
    },
    deleteFilter(state, action: PayloadAction<string>) {
      state.appliedFilters = state.appliedFilters.filter(
        (el) => el !== action.payload
      );
    },
    clearAllFilters(state) {
      state.appliedFilters = [];
    },
    changeModalVisibility(state, action: PayloadAction<boolean>) {
      state.isAddMemberModalOpened = action.payload;
    },
    setMemberDataToEdit(
      state,
      action: PayloadAction<ListMembersResponseElement | null>
    ) {
      state.memberDataToEdit = action.payload;
    },
    setMembersList(state, action: PayloadAction<ListMembersResponseElement[]>) {
      state.membersList = action.payload;
    },
    appendMembersList(
      state,
      action: PayloadAction<ListMembersResponseElement[]>
    ) {
      if (!state.membersList) {
        state.membersList = action.payload;
      } else {
        state.membersList = [...state.membersList, ...action.payload];
      }
    },
    setMemberIdToEdit(state, action: PayloadAction<string | null>) {
      state.memberIdToEdit = action.payload;
    },
    setMemberIdToToggle(state, action: PayloadAction<string | null>) {
      state.memberIdToToggle = action.payload;
    },
    setSorting(
      state,
      action: PayloadAction<{ key: string; order: 'asc' | 'desc' }>
    ) {
      state.sortKey = action.payload.key;
      state.sortOrder = action.payload.order;
    },
  }
});

export const {
  setMembersPageSearchValue,
  clearMembersPageSearchValue,
  addFilter,
  deleteFilter,
  clearAllFilters,
  changeModalVisibility,
  setMemberDataToEdit,
  setMembersList,
  appendMembersList,
  setMemberIdToEdit,
  setMemberIdToToggle,
  setSorting,
} = membersPageSlice.actions;
export default membersPageSlice.reducer;
